import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Sidebar from "../Sidebar";
import ListNotes from "./ListNotes";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { getSessionToken } from "../../lib/sessionToken";

// This page lists the doctor's patients/notes from the last 29 days (see the
// WHERE clause on GET /notes/ in server/routes/notes.js).
const AllNotes = ({ setAuth }) => {
  const [name, setName] = useState("");
  const [allPatients, setAllPatients] = useState([]);
  const [patientsChange, setPatientsChange] = useState(false);
  const [turnaroundTime, setTurnaroundTime] = useState("");
  const [org, setOrg] = useState("");
  const [providerSpecialty, setProviderSpecialty] = useState(null);
  const [superOrg, setSuperOrg] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [submittingPatientId, setSubmittingPatientId] = useState(null);


  async function getName() {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/notes/`, {
        method: "GET",
        headers: { token: getSessionToken() },
      });

      const parseRes = await response.json();
      if (parseRes.length > 0 && parseRes[0]?.user_name) {
        setTurnaroundTime(parseRes[0].turnaround_time);
        setName(parseRes[0].user_name);
        setOrg(parseRes[0].organization);
        setProviderSpecialty(parseRes[0].specialty || null);
        setSuperOrg(parseRes[0].super_org);
      }
      setAllPatients(parseRes);
      setIsLoading(false);
    } catch (err) {
      console.error(err.message);
    }
  }

  useEffect(() => {
    getName();
    setPatientsChange(false);
  }, [patientsChange, isEditing]);

  return (
    <>
      <Helmet><title>All Notes – Knowtex</title></Helmet>
      <Sidebar setAuth={setAuth} />
      {/* Same shell as Dashboard so the Smart Chart workspace rules in index.css
          (fixed main, sidebar margin, Smart Assist offset) apply here too. */}
      <main
        id="main-content"
        tabIndex="-1"
        className="flex min-w-0 mt-5 laptop:mt-0 ml-sidebar-rail desktop:ml-sidebar-open"
      >
        {!isLoading ? (
          <div className="flex w-full min-w-0 flex-col smart-chart-2b-main-column">
            <h1 className="text-3xl text-accent1 font-bold laptop:mt-0 mt-4 smart-chart-2b-page-chrome">
              {name}'s Notes
            </h1>
            <ListNotes
              allPatients={allPatients}
              setPatientsChange={setPatientsChange}
              name={name}
              turnaroundTime={turnaroundTime}
              org={org}
              providerSpecialty={providerSpecialty}
              superOrg={superOrg}
              getName={getName}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              isLoading={isLoading}
              submittingPatientId={submittingPatientId}
              setSubmittingPatientId={setSubmittingPatientId}
            ></ListNotes>
          </div>
        ) : (
          <LoadingScreen />
        )}
      </main>
    </>
  );
};

export default AllNotes;
